import React from 'react';
import { useIntl } from 'react-intl';

import { AlertBanner } from '@api/types/prismic/alertBanner';

import './index.scss';

interface PrismicAlertsBannerProps {
  alert?: AlertBanner;
}

const PrismicAlertsBanner = ({ alert }: PrismicAlertsBannerProps) => {
  const { locale } = useIntl();

  if (!alert) {
    return null;
  }

  const message = locale === 'fr' ? alert.message_fr?.trim() : alert.message_en?.trim();

  if (!message) {
    return null;
  }

  return <div className="PrismicAlertsBanner">{message}</div>;
};

export { PrismicAlertsBanner };
